<form [formGroup]="formGroup" >
<ng-container [formArrayName]="notesFormArrayName">

<div class="container" *ngFor="let noteFormGroup of notesFormArray.controls; let even = even; let odd = odd; let index = index"
    [style.background-color]="odd ? customStyle.colLeft.backgroundColorOdd : even ? customStyle.colLeft.backgroundColorEven : ''">
    <div class="col-left"
        [style.background-color]="odd ? customStyle.colLeft.backgroundColorOdd : even ? customStyle.colLeft.backgroundColorEven : ''"
        *ngIf="displayMode === 'CRUD'">
        <div *ngIf="noteFormGroup.value[noteFormProp.noteAuthorName]">
            {{ noteFormGroup.value[noteFormProp.noteAuthorName] }}
        </div>
        <div *ngIf="noteFormGroup.value[noteFormProp.noteWhenLastUpdated]">
            {{ noteFormGroup.value[noteFormProp.noteWhenLastUpdated] | dateMoment: "ddd DD MMM YYYY" : true }}
        </div>
        <div *ngIf="noteFormGroup.value[noteFormProp.noteWhoLastUpdated]">
            {{ noteFormGroup.value[noteFormProp.noteWhoLastUpdated] }}
        </div>
    </div>
    <div class="col-right e2e-notepad-remarks"
        [style.background-color]="odd ? customStyle.colRight.backgroundColorOdd : even ? customStyle.colRight.backgroundColorEven : ''"
        *ngIf="noteFormGroup.value[noteFormProp.editState] == editState.initial">
        <div class='content'>
            <span [innerHTML]="noteFormGroup.value[noteFormProp.noteText]"></span>
        </div>
        <ng-container *ngIf="isAlwaysEditable || isEditPermission">
            <div class="iconDivDisplayed" id="divButton.{{noteFormGroup.value[noteFormProp.noteXId]}}" *ngIf="isEditable">
                <btn class="action-button"
                     type="actionInlineLink"
                     icon="fa fa-pencil-alt"
                     (keydown.enter)="editNote(noteFormGroup)"
                     (click)="editNote(noteFormGroup)">
                </btn>
                <btn class="action-button"
                     type="actionInlineLink"
                     icon="fa fa-trash"
                     (keydown.enter)="deleteNote(index)"
                     (click)="deleteNote(index)">
                </btn>
            </div>
        </ng-container>
    </div>

    <ng-container *ngIf="isAlwaysEditable || isEditPermission" [formGroup]="noteFormGroup">
        <div class="col-right" [class.isFull]="styleIsFull" *ngIf="noteFormGroup.value[noteFormProp.editState] == editState.edit">
            <div class='content'>
                <!-- maxlength="83" matches GALILEO max notepad length restriction -->
                <input *ngIf="!isRichText; else richTextInput"
                       id="noteEditor.{{noteFormGroup.value[noteFormProp.noteXId]}}"
                       class="notepad-input e2e-notepad-input"
                       maxlength="{{isLengthRestriction ? 83 : ''}}"
                       [formControlName]="noteFormProp.noteText"
                       (change)="editNote(noteFormGroup)"/>

                <ng-template #richTextInput>
                    <!-- On each key stroke, onTextChange is emited... not perfect, but does the job. -->
                    <rich-textarea-field [fieldConfig]="{ formGroup: noteFormGroup, formControlName: noteFormProp.noteText, validators: [] }"
                                         [forceLinkPermission]="true"
                                         (onTextChange)="editNote(noteFormGroup)">
                    </rich-textarea-field>
                </ng-template>
            </div>
            <div class="iconDiv" *ngIf="isEditable">
                <btn *ngIf="!isAlwaysEditable"
                     class="action-button"
                     type="actionInlineLink"
                     icon="fa fa-times"
                     (keydown.enter)="cancelEditNote(index)"
                     (click)="cancelEditNote(index)">
                </btn>
                <btn *ngIf="isAlwaysEditable"
                     class="action-button"
                     type="actionInlineLink"
                     icon="fa fa-trash"
                     (keydown.enter)="deleteNote(index)"
                     (click)="deleteNote(index)">
                </btn>
            </div>
        </div>
    </ng-container>
</div>
</ng-container>

<ng-container *ngIf="isAlwaysEditable || isEditPermission">
    <div class="container" *ngIf="isEditable" >
        <div class="col-left" *ngIf="displayMode === 'CRUD'">
        </div>
        <div class="col-right">
            <btn class="action-button e2e-add-notes"
                 type="actionInlineLink"
                 icon="fa fa-plus"
                 (click)="addNote()"
                 [label]="addNoteLabel">
            </btn>
        </div>
    </div>
</ng-container>
</form>
